import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Flower2, Lock, Mail } from "lucide-react";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#07080B] grid-bg flex items-center justify-center px-4">
      <div className="absolute inset-0 radial-glow" />
      <div className="relative w-full max-w-md glass rounded-3xl p-8 gold-border">
        <div className="flex flex-col items-center mb-8">
          <Flower2 className="w-12 h-12 text-gold animate-spin-slow mb-3" strokeWidth={1.5} />
          <div className="font-syne font-extrabold text-2xl gold-gradient-text">LOTUS LENTERA</div>
          <div className="text-white/50 text-sm mt-1">Panel Admin</div>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <div className="relative">
            <Mail className="w-4 h-4 text-gold absolute left-4 top-1/2 -translate-y-1/2" />
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email admin" data-testid="admin-login-email-input"
              className="w-full bg-white/5 border border-white/10 rounded-xl pl-11 pr-4 py-3.5 text-white outline-none focus:border-gold" />
          </div>
          <div className="relative">
            <Lock className="w-4 h-4 text-gold absolute left-4 top-1/2 -translate-y-1/2" />
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" data-testid="admin-login-password-input"
              className="w-full bg-white/5 border border-white/10 rounded-xl pl-11 pr-4 py-3.5 text-white outline-none focus:border-gold" />
          </div>
          {error && <div className="text-red-400 text-sm" data-testid="admin-login-error">{error}</div>}
          <button disabled={loading} className="btn-gold w-full py-3.5 rounded-xl disabled:opacity-60" data-testid="admin-login-submit">
            {loading ? "Memproses…" : "Masuk"}
          </button>
        </form>
      </div>
    </div>
  );
}
